import React, { useState, useEffect } from 'react'
import { Grid, Segment, Menu, Button, Icon, Header, Table } from 'semantic-ui-react'
import { numFormat } from '@rededompedro/utils'
import _ from 'lodash'
import { DateTime } from 'luxon'
import ModalDetalhes from './ModalDetalhes'

export default function TabelaExtrato({ dados, setDados, form }) {

    const [itemLista, setItemLista] = useState(null)
    const [showModalItem, setShowModalItem] = useState(false)

    useEffect(() => {
        if (itemLista !== null) {
            setShowModalItem(true)
        }
    }, [itemLista])

    function voltarClicked() {
        setDados([])
    }

    function getSomaValor(dado, tipo) {
        if (tipo === 1) {
            let aux = null
            dado.map((x) => (
                aux += x.valor_bruto
            ))
            return numFormat(parseFloat(aux))
        } else if (tipo === 2) {
            let aux = null
            dado.map((x) => (
                aux += x.valor_desconto
            ))
            return numFormat(parseFloat(aux))
        } else if (tipo === 3) {
            let aux = null
            dado.map((x) => (
                aux += x.valor_liquido
            ))
            return numFormat(parseFloat(aux))
        }
    }

    function openModalItem(dados) {
        setItemLista(dados)
    }

    return (
        <div className="col d-flex align-items-center flex-column">
            <Grid style={{ width: '100%' }}>
                <Grid.Column style={{ width: '100%', margin: 0, padding: 0 }}>
                    <Segment basic style={{ padding: '0px 0px' }}>
                        <Menu secondary style={{ margin: 0, marginTop: '15px' }}>
                            <Menu.Item style={{ padding: '12px 0px', margin: 0 }}>
                                <Button size='tiny' icon labelPosition='left' style={{ margin: 0 }} onClick={() => voltarClicked()}>
                                    <Icon name='arrow left' />
                                    Voltar
                            </Button>
                            </Menu.Item>
                            <Menu.Menu position='right'>
                                <Menu.Item style={{ padding: '12px 0px', margin: 0 }}>
                                    <Header floated='right' as='h5' textAlign='right'>
                                        Período de {form.tipoData === 'id_data_venda' ? 'VENDA' : form.tipoData === 'id_data_vencto' ? 'TURNO' : 'PAGAMENTO PREVISTO'}: {form.dataInicio} até {form.dataFim}
                                        <Header.Subheader style={{ color: '#db6023' }}>
                                            {dados[0].restaurante}
                                        </Header.Subheader>
                                    </Header>
                                </Menu.Item>
                            </Menu.Menu>
                        </Menu>
                        {/* <Divider style={{ margin: '1px' }} clearing /> */}
                        <Table color='grey' size='small' singleLine className='mb-5 mt-0' textAlign='center' compact='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Data Venda</Table.HeaderCell>
                                    <Table.HeaderCell>Data Caixa</Table.HeaderCell>
                                    <Table.HeaderCell>Prev. Pagto</Table.HeaderCell>
                                    <Table.HeaderCell>Nº Comprov.</Table.HeaderCell>
                                    <Table.HeaderCell>Tipo Cartão</Table.HeaderCell>
                                    <Table.HeaderCell>Vl. Bruto</Table.HeaderCell>
                                    <Table.HeaderCell>Vl. Descto</Table.HeaderCell>
                                    <Table.HeaderCell>Tx. Descto</Table.HeaderCell>
                                    <Table.HeaderCell>Vl. Líquido</Table.HeaderCell>
                                    <Table.HeaderCell>Consultar</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {_.map(dados, ({ descricao, data_venda, hora_venda, data_caixa, turno, id_prev_pagto, n_comprovante, valor_bruto, valor_desconto, tx_desc, valor_liquido }, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell>{data_venda}, {hora_venda}</Table.Cell>
                                        <Table.Cell>{data_caixa} - {turno}</Table.Cell>
                                        <Table.Cell>{DateTime.fromFormat(id_prev_pagto, 'yyMMdd').toFormat('dd/MM/yyyy')}</Table.Cell>
                                        <Table.Cell>{n_comprovante}</Table.Cell>
                                        <Table.Cell>{descricao}</Table.Cell>
                                        <Table.Cell>{numFormat(valor_bruto)}</Table.Cell>
                                        <Table.Cell>{numFormat(valor_desconto, 4)}</Table.Cell>
                                        <Table.Cell>{numFormat(tx_desc, 4)}</Table.Cell>
                                        <Table.Cell>{numFormat(valor_liquido)}</Table.Cell>
                                        <Table.Cell>
                                            <Button size='tiny' color='vk' onClick={() => openModalItem(dados[index])}>
                                                + Detalhes
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>

                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan='5'>
                                        <Header floated='right' color='blue' style={{ font: 'Ubuntu', fontSize: 18 }}>
                                            Total:
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <Header color='blue' style={{ font: 'Ubuntu', fontSize: 18 }}>
                                            {getSomaValor(dados, 1)}
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <Header color='blue' style={{ font: 'Ubuntu', fontSize: 18 }}>
                                            {getSomaValor(dados, 2)}
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <Header color='blue' style={{ font: 'Ubuntu', fontSize: 18 }}>
                                            -
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <Header color='blue' style={{ font: 'Ubuntu', fontSize: 18 }}>
                                            {getSomaValor(dados, 3)}
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </Segment>
                </Grid.Column>
            </Grid>
            {showModalItem === true &&
                <ModalDetalhes item={itemLista} setItemLista={setItemLista} setShowModalItem={setShowModalItem} />
            }
        </div>
    )
}